import { ErrorAction } from "./error.types";

export const errorSetAction = (message: string): ErrorAction => ({ type: 'ERROR_SET', message })

export const errorClearAction = (): ErrorAction => ({ type: 'ERROR_CLEAR' })